import { CardContainer } from "Infrastructure/Components/ColumnCards/CardContainer";
import { RequestContainer } from "Infrastructure/Components/ColumnCards/RequestsContainer";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { Box, Stack, Typography, useTheme } from "@mui/material";

export const RequestsPage = () => {
  const { t } = useResource();
  const { colors, customSpacing } = useTheme();

  return (
    <Box sx={{ p: 4 }}>
      <Stack
        spacing={customSpacing["2xl"]}
        direction="row"
        alignContent="center"
        justifyContent="center"
      >
        <RequestContainer
          showFilter={true}
          titleKey={Resources.RequestCards.MissionRequests.Title}
          emptyStateKey={Resources.RequestCards.MissionRequests.EmptyState}
          loadingKey={Resources.RequestCards.MissionRequests.Loading}
          errorKey={Resources.RequestCards.MissionRequests.Error}
        />

        <CardContainer title={t(Resources.RequestCards.RewardRequests.Title)}>
          <Typography color={colors.text.secondary}>
            {t(Resources.RequestCards.RewardRequests.EmptyState)}
          </Typography>
        </CardContainer>
      </Stack>
    </Box>
  );
};
